/*
* Transform array of objects
* into array of 'select-like' objects
*
* returns [{ text:String,value:Mixed },...]
*
* @param {array} array - transforming array
* @param {array} fields - list of fields which will be use as text(first) and value(second)
* @param {array} initialValue - initial accumulator value
* */
export default (array, fields, initialValue=[]) =>
	array.reduce( (acc, { [fields[0]]:text, [fields[1]]:value }) => [...acc, {text, value}], initialValue);

